module.exports = __webpack_public_path__ + "media/amenoAmeno.44e5ef68.mp3";